// extracted by mini-css-extract-plugin
module.exports = {"root":"base_root__BfwRm"};